import React from "react";
import TillCheckout from "./components/tillCheckout";

export default function App() {
  let publicIntegrationKey = "MkIVbjwJpxTA9n1epotT";

  // let publicIntegrationKey = "pAjIxkGWLYpv1Yh3FUwF";

  return (
    <React.StrictMode>
      <TillCheckout publicIntegrationKey={publicIntegrationKey} />
    </React.StrictMode>
  );
}
